import paper from 'paper';

export class Dot {
  /**
   * Members
   */
  private _path: any;
  private _element: any;

  /**
   * Constructor
   *
   * @param _format
   * @param _target
   * @param _marker
   */
  public constructor(private _format,
                     private _target,
                     private _marker) {
    this._path = null;
    this._element = null;
    this._init();
  }

  /**
   * Init
   *
   * @protected
   */
  protected _init() {
    this.draw();
  }

  /**
   * Draw
   */
  public draw() {
    const radius = (this._marker && this._marker._model.source && this._marker._model.source.zoom && this._marker._imageScale === 1 ?
      this._marker.container.getStrokeWidth(this._marker._model.source.zoom) || this._format.strokeWidth :
      this._format.strokeWidth)
      / this._marker._imageScale * 2;
    this._element = new paper.Group();
    this._path = new paper.Path.Circle(new paper.Point(this._target.x, this._target.y), radius);
    this._path.strokeColor = this._format.strokeColor;
    this._path.fillColor = (this._marker && this._marker._model.style && this._marker._model.style.color) ?
      this._marker._model.style.color :
      this._format.strokeColor;
    this._path.strokeWidth = 0;
    this._element.addChild(this._path);
  }

  /**
   * Getter element
   */
  public get element() {
    return this._element;
  }

  /**
   * Getter path
   */
  public get path() {
    return this._path;
  }

  /**
   * Set Scale
   */
  public setScale() {
    if (this._path) {
      this._path.remove();
    }
    const radius = (this._marker && this._marker._model.source && this._marker._model.source.zoom && this._marker._imageScale === 1 ?
      this._marker.container.getStrokeWidth(this._marker._model.source.zoom) || this._format.strokeWidth :
      this._format.strokeWidth)
      / this._marker._imageScale * 2;
    this._path = new paper.Path.Circle(new paper.Point(this._target.x, this._target.y), radius);
    this._path.strokeColor = this._format.strokeColor;
    this._path.fillColor = this._format.strokeColor;
    this._path.strokeWidth = 0;
    this._element.addChild(this._path);
  }

  /**
   * Clean Up
   */
  public cleanUp() {
    if (this._element) {
      this._element.remove();
      this._element = null;
    }
  }
}
